import { render } from "./PaymentError.vue?vue&type=template&id=703b8ce0&scoped=true"
import script from "./PaymentError.vue?vue&type=script&lang=js"
export * from "./PaymentError.vue?vue&type=script&lang=js"

import "./PaymentError.vue?vue&type=style&index=0&id=703b8ce0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-703b8ce0"]])

export default __exports__